// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1myuA","productName":"Table_productName__2nrLz"};